/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-12 09:39:53
 */
import React, { FC, useEffect, useState } from "react";
import { Table, Space, Button, message, Select, Form, Modal } from "antd";
import axios from "@/axios/axios";
import { useHistory } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { Option } = Select;
export const HasPayProject = () => {
  let history = useHistory();
  const [year, setYear] = useState(2023);
  const onChange = (pageNumber: any) => {
    let newPage = { ...page, currentPage: pageNumber };
    setPage(newPage);
    setCount(count + 1);
  };
  const [count, setCount] = useState(0);
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 10,
    totalResultSize: 0,
  });
  const [creditVal, setCreditVal] = useState({
    bindCredit: 0,
    surplusCredit: 0,
  });
  useEffect(() => {
    getList();
  }, [count, year]);
  // 纪录列表
  const [list, setList] = useState([]);
  const study = (data: any) => {
    history.push({ pathname: `/index/subject/${data.itemId}` });
  };
  /**
   * 申请学分
   * @param data
   * @returns
   */
  const apply = async (data: any) => {
    Modal.confirm({
      title: "申请学分",
      icon: <ExclamationCircleOutlined />,
      content: `是否要申请学分？`,
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        const { itemId } = data;
        const {
          data: { code, msg },
        }: any = await axios.post(`/shop/front/ce/apply/item/${itemId}/credit`);
        if (code === 0) {
          message.success("操作成功");
          getList();
        } else {
          message.error(msg);
        }
      },
    });
  };
  const getList = async () => {
    const body = {
      userLearnSummaryInfo: {
        year,
      },
      page: {
        currentPage: page.currentPage,
        pageSize: page.pageSize,
      },
    };
    const {
      code,
      data: {
        data: {
          userLearnSummaryInfoList,
          page: { currentPage, totalResultSize },
          bindCredit,
          surplusCredit,
        },
      },
      msg,
    }: any = await axios.post(`/shop/front/ce/user/purchased/item/list`, body);
    if (code === 0) {
      setList(userLearnSummaryInfoList || []);
      setPage({
        ...page,
        currentPage,
        totalResultSize,
      });
      setCreditVal({
        bindCredit,
        surplusCredit,
      });
    } else {
      message.error(msg);
    }
  };
  const columns = [
    {
      title: "项目名称",
      dataIndex: "itemName",
      key: "itemName",
    },
    {
      title: "学分",
      dataIndex: "creditInfo",
      key: "creditInfo",
    },
    {
      title: "项目时长",
      dataIndex: "itemDurationText",
      key: "itemDurationText",
    },
    {
      title: "项目学习状态",
      dataIndex: "learnStatusText",
      key: "learnStatusText",
    },
    {
      title: "申请状态",
      dataIndex: "creditStatusText",
      key: "creditStatusText",
    },
    {
      title: "操作",
      key: "action",
      render: (text: any, record: any) => (
        <Space size="middle">
          <a
            onClick={() => {
              study(record);
            }}
          >
            继续学习
          </a>
          {record.learnStatus === 1 && record.creditStatus === 0 ? (
            <a
              onClick={() => {
                apply(record);
              }}
            >
              申请学分
            </a>
          ) : (
            <a
              style={{
                color: "#cccc",
              }}
            >
              申请学分
            </a>
          )}
        </Space>
      ),
    },
  ];
  const onFinish = () => {};
  return (
    <div>
      <h2>已购项目</h2>
      <Form
        onFinish={onFinish}
        initialValues={{
          year: 2023,
        }}
      >
        <Form.Item name="year">
          <Select
            style={{ width: "200px" }}
            onChange={(value) => {
              setYear(value);
            }}
          >
            <Option value={2023}>2023年度</Option>
          </Select>
        </Form.Item>
      </Form>
      <Table
        bordered={true}
        dataSource={list}
        columns={columns}
        pagination={{ onChange: () => onChange }}
      />
    </div>
  );
};
